import theme from "theme";
import { colors } from "theme/palette";

import Skeleton from "components/Skeleton";
import Stack from "components/Stack";
import Text from "components/Text";

export interface ICategoryTag {
  isLoading: boolean;
  backgroundColor: string;
  text: string;
  count?: number;
  color?: string;
  circleBackgroundColor?: string;
}

const CategoryTag = ({
  isLoading,
  count,
  backgroundColor,
  text,
  color = colors.black,
  circleBackgroundColor = colors.black,
}: ICategoryTag) => (
  <Stack
    spacing={0.5}
    direction="row"
    alignItems="center"
    paddingX={1}
    paddingY={theme.spacing(0.5)}
    sx={{ backgroundColor, borderRadius: "2px" }}
  >
    <Text fontWeight={700} variant="text4" color={color}>
      {text}
    </Text>
    <Text
      fontWeight={700}
      variant="labelSmall"
      style={{
        height: "16px",
        minWidth: "18px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "30px",
        color:
          circleBackgroundColor === colors.white ? colors.black : colors.white,
        backgroundColor: circleBackgroundColor,
        paddingLeft: "1px",
        paddingBottom: "1px",
      }}
    >
      {isLoading ? <Skeleton /> : count}
    </Text>
  </Stack>
);

export default CategoryTag;
